import React from 'react';
import { Footer } from '../components/Footer';
export function ContactThanks() {
  return <div className="w-full bg-white" data-id="element-1227">
      <section className="w-full py-24 sm:py-28" data-id="element-1228">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1229">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-carbon-deep/60" data-id="element-1230">
            Message Received
          </p>
          <h1 className="mt-4 text-[3.5rem] font-bold text-carbon-deep tracking-tight leading-[1.1]" data-id="element-1231">
            Thanks for reaching out.
          </h1>
          <p className="mt-4 text-base sm:text-lg text-carbon-deep/70" data-id="element-1232">
            Our team has received your request. We&apos;ll get back to you as soon as possible.
          </p>
          <a href="/" className="mt-8 inline-flex items-center justify-center rounded-lg bg-[#6bcb78] px-10 py-3 text-sm font-semibold text-white hover:bg-carbon-light transition-colors" data-id="element-1233">
            Back to Home
          </a>
        </div>
      </section>

      <Footer data-id="element-1234" />
    </div>;
}